import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.emailVerificationUserRegistration.pageTitle',
    defaultMessage: 'Verifica email',
    description: 'Title of the email verification user registration page',
  },
  pageSubtitle: {
    id: 'features.emailVerificationUserRegistration.pageSubtitle',
    defaultMessage:
      // eslint-disable-next-line quotes
      "Inserisci il codice che è stato inviato all'indirizzo email scelto",
    description: 'Subtitle of the email verification user registration page',
  },
  buttonSendCodeByMail: {
    id: 'features.emailVerificationUserRegistration.buttonSendCodeByMail',
    defaultMessage: 'Invia codice',
    description:
      'Label of the email verification user registration button send code',
  },
  labelInsertEmailInputTextDisabled: {
    id: 'features.emailVerificationUserRegistration.labelInsertEmailInputTextDisabled',
    defaultMessage: 'Email',
    description: 'Label of email input text disabled',
  },
  labelInsertCodeVerificationInputText: {
    id: 'features.emailVerificationUserRegistration.labelInsertCodeVerificationInputText',
    defaultMessage: 'Codice di verifica',
    description: 'Label of verification code input text',
  },
  placeholderInsertCodeVerificationInputText: {
    id: 'features.emailVerificationUserRegistration.placeholderInsertCodeVerificationInputText',
    defaultMessage: 'Inserisci il tuo codice di verifica',
    description: 'Placeholder of verification code input text',
  },
  descriptionDisclaimer: {
    id: 'features.emailVerificationUserRegistration.descriptionDisclaimer',
    defaultMessage:
      'In caso di mancata ricezione dell’email , verifica nella cartella spam. Se non hai ricevuto l’email, è possibile contattare telefonicamente il servizio di assistenza dedicato, al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00. (Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'Text of description disclaimer',
  },
  buttonVerificationCodeByMail: {
    id: 'features.emailVerificationUserRegistration.buttonVerificationCodeByMail',
    defaultMessage: 'Verifica',
    description:
      'Label of the email verification user registration button verification code',
  },
  errorWrongCode: {
    id: 'features.emailVerificationUserRegistration.errorWrongCode',
    defaultMessage:
      'Il codice inserito non è corretto. Riprova. Tentativi rimasti: {attempts}',
    description: 'Error wrong code verification email ',
  },
  errorEmailNotUsableTitle: {
    id: 'features.emailVerificationUserRegistration.errorEmailNotUsableTitle',
    defaultMessage: 'Attenzione!',
    description: 'Error title email not usable verification email ',
  },
  errorEmailNotUsableMessages: {
    id: 'features.emailVerificationUserRegistration.errorEmailNotUsableMessages',
    defaultMessage:
      'L’indirizzo email risulta già associato ad un altro contratto MyAzimut. Si prega di inserire un altro indirizzo email',
    description: 'Error messages email not usable verification email ',
  },
  errorEmailNotUsableButtonLabel: {
    id: 'features.emailVerificationUserRegistration.errorEmailNotUsableButtonLabel',
    defaultMessage: 'OK',
    description: 'Label button error email not usable verification email ',
  },
  errorTooManyAttemptsTitle: {
    id: 'features.emailVerificationUserRegistration.errorTooManyAttemptsTitle',
    defaultMessage: 'Attenzione!',
    description:
      'Title error too many attempts for dialog email verification page ',
  },
  errorTooManyAttemptsMessage: {
    id: 'features.emailVerificationUserRegistration.errorTooManyAttempts',
    defaultMessage:
      'Attenzione! Hai raggiunto il limite di tentativi disponibili per verificare l’email inserita. Inserisci nuovamente l’indirizzo email per procedere con la verifica.',
    description:
      'Error message too many attempts for dialog email verification page ',
  },
  errorTooManyAttemptsButtonLabel: {
    id: 'features.emailVerificationUserRegistration.errorTooManyAttemptsButtonLabel',
    defaultMessage: 'OK',
    description:
      'Label button error too many attempts for dialog email verification page ',
  },
  errorAccordoQuadroNonAttivo: {
    id: 'features.emailVerificationUserRegistration.errorAccordoQuadroNonAttivo',
    defaultMessage:
      'Attenzione! Impossibile procedere con la registrazione per accordo quadro non attivo.',
    description:
      'Error message accordo quadro not active',
  },
});
